import React, { useEffect, useState } from 'react';
import Highlight from 'react-highlight';
import Masonry from 'masonry-layout';
import { Card, CardHeader, CardHeaderBtn, CardBody, CardGroup, CardImgOverlay } from './../../components/card/card.jsx';
import { NavScrollTo } from './../../components/nav-scroll-to/nav-scroll-to.jsx';

function UiCard() {
	const [code1, setCode1] = useState();
	const [code2, setCode2] = useState();
	const [code3, setCode3] = useState();
	const [code4, setCode4] = useState();
	const [code5, setCode5] = useState();
	const [code6, setCode6] = useState();
	const [code7, setCode7] = useState();
	const [code8, setCode8] = useState();
	const [code9, setCode9] = useState();
	const [code10, setCode10] = useState();
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/ui/card-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		fetch('/quantum-react/assets/data/ui/card-code-2.json').then(function(response) { return response.text(); }).then((html) => { setCode2(html); });
		fetch('/quantum-react/assets/data/ui/card-code-3.json').then(function(response) { return response.text(); }).then((html) => { setCode3(html); });
		fetch('/quantum-react/assets/data/ui/card-code-4.json').then(function(response) { return response.text(); }).then((html) => { setCode4(html); });
		fetch('/quantum-react/assets/data/ui/card-code-5.json').then(function(response) { return response.text(); }).then((html) => { setCode5(html); });
		fetch('/quantum-react/assets/data/ui/card-code-6.json').then(function(response) { return response.text(); }).then((html) => { setCode6(html); });
		fetch('/quantum-react/assets/data/ui/card-code-7.json').then(function(response) { return response.text(); }).then((html) => { setCode7(html); });
		fetch('/quantum-react/assets/data/ui/card-code-8.json').then(function(response) { return response.text(); }).then((html) => { setCode8(html); });
		fetch('/quantum-react/assets/data/ui/card-code-9.json').then(function(response) { return response.text(); }).then((html) => { setCode9(html); });
		fetch('/quantum-react/assets/data/ui/card-code-10.json').then(function(response) { return response.text(); }).then((html) => { setCode10(html); });
		
		new Masonry('[data-masonry]');
	});
	
	return (
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-xl-10">
					<div className="row">
						<div className="col-xl-9">
							<ul className="breadcrumb">
								<li className="breadcrumb-item"><a href="#/">UI KITS</a></li>
								<li className="breadcrumb-item active">CARD</li>
							</ul>
							
							<h1 className="page-header">
								Card <small>page header description goes here...</small>
							</h1>
							
							<hr className="mb-4 opacity-3" />
							
							<div id="basicUsage" className="mb-5">
								<h4>Basic Usage</h4>
								<p>
									Bootstrap’s Cards provide a flexible and extensible content container with multiple variants and options.
									Please read the <a href="https://getbootstrap.com/docs/5.3/components/Card/" target="_blank" rel="noreferrer">official Bootstrap documentation</a> for the full list of options.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-6">
												<Card>
													<CardHeader>
														CARD HEADER HERE
													</CardHeader>
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<h6 className="card-subtitle mb-3 text-body text-opacity-50">Card subtitle</h6>
														<p className="card-text mb-3">Some quick example text to build on the Card title and make up the bulk of the Card's content.</p>
														<a href="#/" className="card-link">Card link</a>
														<a href="#/" className="card-link">Another link</a>
													</CardBody>
												</Card>
											</div>
											<div className="col-xl-6">
												<Card>
													<CardHeader>
														CARD WITH LIST GROUP
													</CardHeader>
													<CardHeader className="bg-none p-0">
														<ul className="list-group">
															<li className="list-group-item">Cras justo odio</li>
															<li className="list-group-item">Dapibus ac facilisis in</li>
															<li className="list-group-item">Vestibulum at eros</li>
														</ul>
													</CardHeader>
													<CardBody>
														<a href="#/" className="card-link">Card link</a>
														<a href="#/" className="card-link">Another link</a>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code1}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="fullscreen" className="mb-5">
								<h4>Fullscreen (extended feature)</h4>
								<p>
									This is an extended feature from Bootstrap Card. Add the component
									<code>CardHeaderBtn</code> to having the following buttons
									the maximize or minimize the Card element
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-lg-8">
												<Card>
													<CardHeader className="with-btn">
														CARD HEADER HERE
														<CardHeaderBtn />
													</CardHeader>
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<h6 className="card-subtitle mb-3 text-body text-opacity-50">Card subtitle</h6>
														<p className="card-text mb-3">Some quick example text to build on the Card title and make up the bulk of the Card's content.</p>
														<a href="#/" className="card-link">Card link</a>
														<a href="#/" className="card-link">Another link</a>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code2}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="sizing" className="mb-5">
								<h4>Sizing</h4>
								<p>
									Cards assume no specific <code>width</code> to start, so they’ll be 100% wide unless otherwise stated. You can change this as needed with custom CSS, grid classes, grid Sass mixins, or utilities.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-sm-8">
												<Card>
													<CardBody>
														<h5 className="card-title">Special title treatment</h5>
														<p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
														<a href="#/" className="btn btn-outline-theme">Go somewhere</a>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code3}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="navigation" className="mb-5">
								<h4>Navigation</h4>
								<p>
									Add some navigation to a Card’s header (or block) with Bootstrap’s nav components.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">NAV TABS</b></div>
												<Card className="mb-3">
													<CardHeader>
														<ul className="nav nav-tabs CardHeader-tabs fw-semibold">
															<li className="nav-item me-2">
																<a className="nav-link active" href="#/">ACTIVE</a>
															</li>
															<li className="nav-item me-2">
																<a className="nav-link" href="#/">LINK</a>
															</li>
															<li className="nav-item me-2">
																<a className="nav-link disabled" href="#/">DISABLED</a>
															</li>
														</ul>
													</CardHeader>
													<CardBody>
														<h5 className="card-title">Special title treatment</h5>
														<p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
														<a href="#/" className="btn btn-theme">Go somewhere</a>
													</CardBody>
												</Card>
											</div>
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">NAV PILLS</b></div>
												<Card className="mb-3">
													<CardHeader>
														<ul className="nav nav-pills CardHeader-pills fw-semibold">
															<li className="nav-item me-2">
																<a className="nav-link active" href="#/">ACTIVE</a>
															</li>
															<li className="nav-item me-2">
																<a className="nav-link" href="#/">LINK</a>
															</li>
															<li className="nav-item me-2">
																<a className="nav-link disabled" href="#/">DISABLED</a>
															</li>
														</ul>
													</CardHeader>
													<CardBody>
														<h5 className="card-title">Special title treatment</h5>
														<p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
														<a href="#/" className="btn btn-theme">Go somewhere</a>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code4}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="images" className="mb-5">
								<h4>Images</h4>
								<p>
									Cards include a few options for working with images. Choose from appending “image caps” at either end of a Card, overlaying images with Card content, or simply embedding the image in a Card.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">IMAGE CAPS</b></div>
												<Card className="mb-3">
													<CardBody>
														<img src="https://placehold.co/600x400/c9d2e3/212837" alt="" className="card-img-top" />
													</CardBody>
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">IMAGE OVERLAY</b></div>
												<Card className="mb-3">
													<img src="https://placehold.co/600x600/051016/ffffff" alt="" className="card-img" />
													<CardImgOverlay>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardImgOverlay>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code5}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="horizontal" className="mb-5">
								<h4>Horizontal</h4>
								<p>
									Using a combination of grid and utility classes, Cards can be made horizontal in a mobile-friendly and responsive way.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row gx-0 align-items-center">
											<div className="col-md-3">
												<img src="https://placehold.co/480x360/c9d2e3/212837" alt="" className="card-img" />
											</div>
											<div className="col-md-9 p-3">
												<h5 className="card-title">Card title</h5>
												<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
												<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code6}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="CardStyles" className="mb-5">
								<h4>Card Styles</h4>
								<p>
									Cards include various options for customizing their backgrounds, borders, and color.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">BACKGROUND AND BORDER</b></div>
												<Card className="mb-3">
													<CardHeader className="bg-theme bg-opacity-15">HEADER</CardHeader>
													<CardBody className="bg-theme bg-opacity-30 text-white">
														<h5 className="card-title">Primary Card title</h5>
														<p className="card-text text-body text-opacity-75">Some quick example text to build on the Card title and make up the bulk of the Card's content.</p>
													</CardBody>
												</Card>
											</div>
											<div className="col-xl-6">
												<div className="small text-body text-opacity-50 mb-3"><b className="fw-bold">BORDER AND COLOR</b></div>
												<Card className="mb-3">
													<CardHeader className="text-theme">HEADER</CardHeader>
													<CardBody>
														<h5 className="card-title text-theme">Primary Card title</h5>
														<p className="card-text text-theme text-opacity-75">Some quick example text to build on the Card title and make up the bulk of the Card's content.</p>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code7}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="CardGroups" className="mb-5">
								<h4>Card groups</h4>
								<p>
									Use Card groups to render Cards as a single, attached element with equal width and height columns. Card groups use <code>display: flex;</code> to achieve their uniform sizing.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<CardGroup className="m-n1">
											<Card className="m-1">
												<CardBody>
													<h5 className="card-title">Card title</h5>
													<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
													<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
												</CardBody>
											</Card>
											<Card className="m-1">
												<CardBody>
													<h5 className="card-title">Card title</h5>
													<p className="card-text">This Card has supporting text below as a natural lead-in to additional content.</p>
													<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
												</CardBody>
											</Card>
											<Card className="m-1">
												<CardBody>
													<h5 className="card-title">Card title</h5>
													<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This Card has even longer content than the first to show that equal height action.</p>
													<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
												</CardBody>
											</Card>
										</CardGroup>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code8}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="gridCards" className="mb-5">
								<h4>Grid Cards</h4>
								<p>
									Use the Bootstrap grid system and its <a href="https://getbootstrap.com/docs/5.3/layout/grid/#row-columns"><code>.row-cols</code> classes</a> to control how many grid columns (wrapped around your Cards) you show per row. For example, here’s <code>.row-cols-1</code> laying out the Cards on one column, and <code>.row-cols-md-2</code> splitting four Cards to equal width across multiple rows, from the medium breakpoint up.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row row-cols-1 row-cols-md-2 g-3">
											<div className="col">
												<Card className="h-100">
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col">
												<Card className="h-100">
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This Card has supporting text below as a natural lead-in to additional content.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col">
												<Card className="h-100">
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This Card has even longer content than the first to show that equal height action.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col">
												<Card className="h-100">
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is a wider Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code9}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="CardColumns" className="mb-5">
								<h4>Card columns</h4>
								<p>
									In <code>v5</code>, Cards can be organized into Masonry-like columns with masonry javascript included.
								</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row g-3" data-masonry='{"percentPosition": true }'>
											<div className="col-sm-6 col-lg-4">
												<Card>
													<CardBody>
														<h5 className="card-title">Card title that wraps to a new line</h5>
														<p className="card-text">This is a longer Card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
													</CardBody>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card>
													<blockquote className="blockquote mb-0 card-body">
														<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
														<footer className="blockquote-footer">
															<small className="text-body text-opacity-50">
																Someone famous in <cite title="Source Title">Source Title</cite>
															</small>
														</footer>
													</blockquote>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card>
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This Card has supporting text below as a natural lead-in to additional content.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card className="text-center">
													<blockquote className="blockquote mb-0 card-body">
														<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat.</p>
														<footer className="blockquote-footer text-white">
															<small>
																Someone famous in <cite title="Source Title">Source Title</cite>
															</small>
														</footer>
													</blockquote>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card className="text-center">
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This Card has a regular title and short paragraphy of text below it.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card className="text-end">
													<blockquote className="blockquote mb-0 card-body">
														<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
														<footer className="blockquote-footer">
															<small className="text-body text-opacity-50">
																Someone famous in <cite title="Source Title">Source Title</cite>
															</small>
														</footer>
													</blockquote>
												</Card>
											</div>
											<div className="col-sm-6 col-lg-4">
												<Card>
													<CardBody>
														<h5 className="card-title">Card title</h5>
														<p className="card-text">This is another Card with title and supporting text below. This Card has some additional content to make it slightly taller overall.</p>
														<p className="card-text"><small className="text-body text-opacity-50">Last updated 3 mins ago</small></p>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='javascript'>{code10}</Highlight>
									</div>
								</Card>
							</div>
						</div>
						<div className="col-xl-3">
							<NavScrollTo>
								<nav className="nav">
									<a className="nav-link" href="#basicUsage" data-toggle="scroll-to">Basic usage</a>
									<a className="nav-link" href="#fullscreen" data-toggle="scroll-to">Fullscreen (extended feature)</a>
									<a className="nav-link" href="#sizing" data-toggle="scroll-to">Sizing</a>
									<a className="nav-link" href="#navigation" data-toggle="scroll-to">Navigation</a>
									<a className="nav-link" href="#images" data-toggle="scroll-to">Images</a>
									<a className="nav-link" href="#horizontal" data-toggle="scroll-to">Horizontal</a>
									<a className="nav-link" href="#cardStyles" data-toggle="scroll-to">Card styles</a>
									<a className="nav-link" href="#cardGroups" data-toggle="scroll-to">Card groups</a>
									<a className="nav-link" href="#gridCards" data-toggle="scroll-to">Grid cards</a>
									<a className="nav-link" href="#cardColumns" data-toggle="scroll-to">Card columns</a>
								</nav>
							</NavScrollTo>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UiCard;